import { StateCreator } from "zustand";
import { FetchMonthlyExpenseReportType } from "../../../domain/models/expense-dashboard/fetch-monthly-expense-report";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { FetchMonthlyExpenseReport } from "../../../domain/useages/expense-dashboard/fetch-monthly-expense-report";
import { RemoteFetchMonthlyExpenseReport } from "../../../data/usecases/expense-dashboard/remote-fetch-monthly-expense-report";

export interface FetchMonthlyExpenseReportInterface {
  FetchMonthlyExpenseReport: FetchMonthlyExpenseReportType;
  FetchMonthlyExpenseReportState: FetchState;
  fetchMonthlyExpenseReport: Function;
}

const initialStates = {
  FetchMonthlyExpenseReport: {} as FetchMonthlyExpenseReportType,
  FetchMonthlyExpenseReportState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchMonthlyExpenseReportSlice: StateCreator<
  FetchMonthlyExpenseReportInterface
> = (set) => ({
  ...initialStates,
  fetchMonthlyExpenseReport: async (
    params: FetchMonthlyExpenseReport.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMonthlyExpenseReport = new RemoteFetchMonthlyExpenseReport(
      `${BASE_URL}${Endpoints.FETCH_MONTHLY_EXPENSE_REPORT}`,
      axiosHttpClient
    );

    set(() => ({ FetchMonthlyExpenseReportState: FetchState.LOADING }));
    let result = await remoteFetchMonthlyExpenseReport.fetch(params);
    return result;
  },
});
